import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAdminUserAccounts,
  updateAdminUserStatus,
} from "../../api/admin/userAccounts.api";

/* =============================================================
   FETCH USERS
============================================================= */
export const fetchUserAccounts = createAsyncThunk(
  "admin/userAccounts/fetch",
  async ({ page = 1, limit = 10, search = "" }, { rejectWithValue }) => {
    const res = await getAdminUserAccounts({ page, limit, search });

    if (!res.success) {
      return rejectWithValue(res.message);
    }

    return res;
  }
);

/* =============================================================
   UPDATE USER STATUS (Enable / Disable)
============================================================= */
export const updateUserStatus = createAsyncThunk(
  "admin/userAccounts/updateStatus",
  async ({ id, isActive }, { rejectWithValue }) => {
    const res = await updateAdminUserStatus(id, isActive);

    if (!res.success) {
      return rejectWithValue(res.message);
    }

    return {
      id,
      is_active: isActive ? 1 : 0,
    };
  }
);
